import React from 'react';
import './styles.css';
import { Avatar, Row, Col } from 'antd';

const Item = ({ description, downloadLink, src, title }) => {
  return (
    <Row className="item-container_row">
      <Col
        span={24}
        className="item-container_col"
        align="middle"
        justify="center"
      >
        <Avatar
          size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
          src={src}
        />

        <h3 className="item-container_title">{title}</h3>

        <h4 className="item-container_description">
          {description} {downloadLink}
        </h4>
      </Col>
    </Row>
  );
};

export default Item;
